import Vue from 'vue'
import Vuex from 'vuex'
import { DEFAULT_LOCALE, getLocaleFromPath, normalizeLocale } from '../router/locale'

Vue.use(Vuex)

const initialLang = getLocaleFromPath() || DEFAULT_LOCALE

document.documentElement.lang = initialLang

export default new Vuex.Store({
  state: {
    lang: initialLang
  },
  mutations: {
    setLang(state, lang) {
      const nextLang = normalizeLocale(lang) || DEFAULT_LOCALE
      state.lang = nextLang
      localStorage.setItem('flymeta_lang', nextLang)
      document.documentElement.lang = nextLang
    }
  },
  actions: {
  },
  getters: {
    lang(state) {
      return state.lang
    }
  }
})
